import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feaadfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-sm-10 col-md-8 col-lg-5" }
const _hoisted_2 = { class: "middle-box" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  key: 0,
  class: "card-body p-4"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-24 mb-30" }, "ログイン", -1))
const _hoisted_7 = { action: "#" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group mb-0" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ログイン ")
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-dark m-auto"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "mx-auto mt-3 text-center text-danger font-weight-bold"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-24 mb-30" }, "ワンタイム認証", -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "手動設定キーまたはQRコードを保管してください。", -1))
const _hoisted_21 = ["action"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group mb-0" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" ログイン ")
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-dark m-auto"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "mx-auto mt-3 text-center text-danger font-weight-bold"
}
const _hoisted_30 = {
  key: 1,
  class: "card-body p-4"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-24 mb-30" }, "パスワード忘れ", -1))
const _hoisted_32 = { action: "#" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "form-group mb-0" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 送信 ")
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-dark m-auto"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "mx-auto mt-3 text-center text-danger font-weight-bold"
}
const _hoisted_41 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "確認番号", -1))
const _hoisted_43 = {
  class: "text-center font-24",
  style: {"font-weight":"700"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isForget)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!_ctx.is2fa)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "btn btn-link float-right",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isForget = true))
                    }, " パスワード忘れ "),
                    _hoisted_6,
                    _createElementVNode("form", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control border-input",
                          placeholder: "メールアドレス",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.auth.username) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.auth.username]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control border-input",
                          placeholder: "パスワード",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.auth.password) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.auth.password]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: _normalizeClass(["btn btn-primary btn-block lodingBtn", { loding: _ctx.isLoading }]),
                          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
                          disabled: _ctx.isLoading
                        }, [
                          _hoisted_12,
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("figure", _hoisted_13, _hoisted_15))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_11),
                        (_ctx.errorMessage !== '')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errorMessage), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("img", { src: _ctx.barcodeImageUrl }, null, 8, _hoisted_19),
                    _createElementVNode("p", null, "手動設定キー: " + _toDisplayString(_ctx.manualKey), 1),
                    _hoisted_20,
                    _createElementVNode("div", null, _toDisplayString(_ctx.errorTwoFaMessage), 1),
                    _createElementVNode("form", {
                      method: "POST",
                      id: "from",
                      action: _ctx.endpoint + '/auth/login?redirect=' + _ctx.redirectUrl
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        name: "Username",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.auth.username) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.auth.username]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        name: "Password",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.auth.password) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.auth.password]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        name: "Passcode",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passcode) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passcode]
                      ])
                    ], 8, _hoisted_21),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control border-input",
                        name: "Passcode",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.passcode) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passcode]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(["btn btn-primary btn-block lodingBtn", { loding: _ctx.isLoading }]),
                        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args)), ["prevent"])),
                        disabled: _ctx.isLoading
                      }, [
                        _hoisted_25,
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("figure", _hoisted_26, _hoisted_28))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_24),
                      (_ctx.errorTwoFaMessage !== '')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.errorTwoFaMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-link float-right",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isForget = false))
                }, " 戻る "),
                _hoisted_31,
                _createElementVNode("form", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control border-input",
                      placeholder: "メールアドレス",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.forgetMail) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.forgetMail]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["btn btn-primary btn-block lodingBtn", { loding: _ctx.isLoading }]),
                      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forget && _ctx.forget(...args)), ["prevent"])),
                      disabled: _ctx.isLoading
                    }, [
                      _hoisted_36,
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("figure", _hoisted_37, _hoisted_39))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_35),
                    (_ctx.errorMessage !== '')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.hasForgetKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.forgetKey), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ])
  ]))
}